import { Timestamp } from 'firebase/firestore';

export interface ProductModel extends CreateProductModel {
    id: string;
}

export interface CreateProductModel extends CreateProductFromFormModel {
    externalReference?: string;
    createdAt: Timestamp | string;
    updatedAt: Timestamp | string;
    deletedAt?: Timestamp | string;
    productGuid: string;
    baseAmountValueInclVat: number;
    totalAmount: number;
    totalAmountInclVat: number;
    companyId: string;
    syncedAt?: Timestamp | string;
}

export interface CreateProductFromFormModel {
    productNumber?: string;
    name?: string;
    baseAmountValue: number;
    quantity: number;
    accountNumber: number;
    unit: ProductUnitModel;
    comment?: string;
}

export type ProductUnitModel =
    "hours" |
    "parts" |
    "km" |
    "day" |
    "week" |
    "month" |
    "kilogram" |
    "cubicMetre" |
    "set" |
    "litre" |
    "box" |
    "case" |
    "carton" |
    "metre" |
    "package" |
    "shipment" |
    "squareMetre" |
    "session" |
    "tonne";

export type DisplayProductUnitModel =
    "timer" |
    "stk." |
    "km" |
    "dag" |
    "uge" |
    "måned" |
    "kilogram" |
    "kubikmeter" |
    "sæt" |
    "liter" |
    "boks" |
    "kasse" |
    "karton" |
    "meter" |
    "pakke" |
    "forsendelse" |
    "kvadratmeter" |
    "session" |
    "ton";

// Translation mapping from API units to display units
export const UNIT_TRANSLATIONS: Record<ProductUnitModel, DisplayProductUnitModel> = {
    "hours": "timer",
    "parts": "stk.",
    "km": "km",
    "day": "dag",
    "week": "uge",
    "month": "måned",
    "kilogram": "kilogram",
    "cubicMetre": "kubikmeter",
    "set": "sæt",
    "litre": "liter",
    "box": "boks",
    "case": "kasse",
    "carton": "karton",
    "metre": "meter",
    "package": "pakke",
    "shipment": "forsendelse",
    "squareMetre": "kvadratmeter",
    "session": "session",
    "tonne": "ton"
};

export const REVERSE_UNIT_TRANSLATIONS: Record<DisplayProductUnitModel, ProductUnitModel> =
    Object.fromEntries(
        Object.entries(UNIT_TRANSLATIONS).map(([key, value]) => [value, key])
    ) as Record<DisplayProductUnitModel, ProductUnitModel>;

// Helper functions for translation
export const translateUnitToDisplay = (dineroUnit: ProductUnitModel): DisplayProductUnitModel => {
    return UNIT_TRANSLATIONS[dineroUnit] || dineroUnit as DisplayProductUnitModel;
};

export const translateUnitToDinero = (displayUnit: DisplayProductUnitModel): ProductUnitModel => {
    return REVERSE_UNIT_TRANSLATIONS[displayUnit] || displayUnit as ProductUnitModel;
};

// Get all available units for display in dropdown/picker
export const getAvailableDisplayUnits = (): { label: DisplayProductUnitModel; value: ProductUnitModel }[] => {
    return Object.entries(UNIT_TRANSLATIONS).map(([dineroUnit, displayUnit]) => ({
        label: displayUnit,
        value: dineroUnit as ProductUnitModel
    }));
};
